import AccountCategoryMaster from "../Master/AccountMaster/AccountCategoryMaster";
import AccountGroupMaster from "../Master/AccountMaster/AccountGroupMaster";
import DepartmentDetails from "../Master/Userdetails/DepartmentMaster";
import MiscellaneousMaster from "../Master/AccountMaster/MiscellaneousMaster";
import StationMaster from "../Master/AccountMaster/StationMaster";
import ItemGroupMaster from "../Master/InvertoryMaster/ItemGroupMaster";
import UnitMaster from "../Master/InvertoryMaster/UnitMaster";
import DesignationDetails from "../Master/Userdetails/DesignationMaster";
import ItemDepartmentMaster from "../Master/Userdetails/ItemDepartmentMaster";
import MealCourseMaster from "../ModalBox/MealCourseMaster";
import TransportMaster from "../Master/AccountMaster/TransportMaster";
import IncentiveMaster from "../Master/Userdetails/IncentiveMaster";
import TableMaster from "../Master/TableMaster/TableMaster";
import TableGroup from "../Master/TableMaster/TableGroupList";
import TransactionTypeList from "../Master/TransactionTypeSetting/TransactionTypeList";
import SoftwareConfigurationPopUP from "../LogInPage/SoftwareConfigurationPopUP";
import MasterListReportFormat2 from "../Utilities/ReportSetting/MasterListReportFormat2";
import MastersModalBox from "./MastersModalBox";
import GodownMaster from "../Master/InvertoryMaster/GodownMaster";

function ModalBoxMaster({
  handleModalClick,
  hideModal3,
  isModalStationMaster,
  isModalOpen2,
  hideModal2,
  hideTransporter,
  transportModal,
  hideModalDepartmentDetails,
  isModalOpenDepartmentDetails,
  hideModalDesignationDetails,
  isModalOpenDesignationDetails,
  hideModalAccCategoryMaster,
  isModalOpenAccCategoryMaster,
  hideMiscellaneous,
  isModalMiscellaneous,
  hideUnit,
  isModalOpenUnit,
  hideGroupName,
  isModalOpenGroupName,
  showGroupName,
  hideDepartment,
  isDepartment,
  hideMeal,
  isMealCourse,
  controlType,
  deliveryIncentiveModal,
  hideDeliveryIncentive,
  closeTableGroupModal,
  tableGroupModal,
  closeTableMaster,
  isOpenTableMaster,
  tableGroupId,
  CloseTransactionType,
  isOpenTransactionType,
  isSoftwareConfigOpen,
  toggleSoftwareConfigOpen,
  isMasterListReportFormat2,
  toggleMasterListReportFormat2,
  isGodownMasterShow,
  hideGodownMaster
}) {
  return (
    <div>
      {/* *****************************{Godown Master}****************************** */}
      {isGodownMasterShow && (
        <MastersModalBox closeModal={hideGodownMaster}>
          <GodownMaster
            hideGodownMaster={hideGodownMaster}
            isBackButton={false}
            isLogoutButton={true}
            SaveButtonName={"Save/F4"}
            isF4ListenForSave={true}
          />
        </MastersModalBox>
      )}
      {/* *****************************{Station Master}****************************** */}
      {isModalStationMaster && (
        <MastersModalBox closeModal={hideModal3}>
          <StationMaster
            isBackButton={false}
            isLogoutButton={true}
            SaveButtonName={"Save/F4"}
            isF4ListenForSave={true}
          />
        </MastersModalBox>
      )}
      {/* *****************************{Account Group Master}****************************** */}
      {isModalOpen2 && (
        <MastersModalBox closeModal={hideModal2}>
          <AccountGroupMaster
            isBackButton={false}
            isLogoutButton={true}
            SaveButtonName={"Save/F4"}
            isF4ListenForSave={true}
          />
        </MastersModalBox>
      )}
      {/******************************{Department Details}*******************************/}
      <div>
        {isModalOpenDepartmentDetails && (
          <MastersModalBox closeModal={hideModalDepartmentDetails}>
            <DepartmentDetails
              isBackButton={false}
              isLogoutButton={true}
              SaveButtonName={"Save/F4"}
              isF4ListenForSave={true}
            />
          </MastersModalBox>
        )}
      </div>
      {/* *****************************{Designation Details}****************************** */}
      <div>
        {isModalOpenDesignationDetails && (
          <MastersModalBox closeModal={hideModalDesignationDetails}>
            <DesignationDetails
              isBackButton={false}
              isLogoutButton={true}
              SaveButtonName={"Save/F4"}
              isF4ListenForSave={true}
            />
          </MastersModalBox>
        )}
      </div>
      {/* *****************************{Account Category Master}****************************** */}
      <div>
        {isModalOpenAccCategoryMaster && (
          <MastersModalBox closeModal={hideModalAccCategoryMaster}>
            <DesignationDetails
              isBackButton={false}
              isLogoutButton={true}
              SaveButtonName={"Save/F4"}
              isF4ListenForSave={true}
            />
          </MastersModalBox>
        )}
      </div>
      {/* *****************************{Miscellaneous Master}****************************** */}
      {isModalMiscellaneous && (
        <MastersModalBox closeModal={hideMiscellaneous}>
          <MiscellaneousMaster
            isBackButton={false}
            isLogoutButton={true}
            SaveButtonName={"Save/F4"}
            isF4ListenForSave={true}
            controlType={controlType} />
        </MastersModalBox>
      )}
      {/* *****************************{Unit Master}****************************** */}
      {isModalOpenUnit && (
        <MastersModalBox closeModal={hideUnit}>
          <UnitMaster
          hideUnit={hideUnit}
            isBackButton={false}
            isLogoutButton={true}
            SaveButtonName={"Save/F4"}
            isF4ListenForSave={true}
          />
        </MastersModalBox>
      )}
      {/* *****************************{Item Group Master1}****************************** */}
      {isModalOpenGroupName && (
        <MastersModalBox closeModal={hideGroupName}>
          <ItemGroupMaster
            isBackButton={false}
            isLogoutButton={true}
            hideGroupName={hideGroupName}
            SaveButtonName={"Save/F4"}
            isF4ListenForSave={true}
          />
        </MastersModalBox>
      )}
      {/* ******************************* Table Master ************************* */}
      {tableGroupModal && (
        <div onClick={closeTableGroupModal} className="modal">
          <div className="OpticalField-modal increase_modal">
            <div className="modal-title">
              {/* <h3 className="modal-box-m1">Add New Category</h3> */}
              <span className="close_modal" onClick={closeTableGroupModal}>
                &times;
              </span>
            </div>
            <div className="">
              <div className="tab-content-modal">
                <div className="company-info-top-modal control_flex_modal item_scroll">
                  {/* <ItemGroupMaster /> */}
                  <TableGroup openModal={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* *****************************{Item Department Master}****************************** */}
      {/* {isDepartment && (
        <div onClick={hideDepartment} className="modal">
          <div
            onClick={handleModalClick}
            className="OpticalField-modal increase_modal"
          >
            <div className="modal-title">

              <span className="close_modal" onClick={hideDepartment}>
                &times;
              </span>
            </div>
            <div className="">
              <div className="tab-content-modal">
                <div className="company-info-top-modal control_flex_modal item_scroll">
                  <ItemDepartmentMaster
                    isBackButton={false}
                    isLogoutButton={true}
                    SaveButtonName={"Save"}
                    isF4ListenForSave={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {isDepartment && (

        <MastersModalBox closeModal={hideDepartment}>
          <ItemDepartmentMaster
            isBackButton={false}
            isLogoutButton={true}
            SaveButtonName={"Save/F4"}
            isF4ListenForSave={true}
          />
        </MastersModalBox>
      )}
      {/* *****************************{Meal Course Master}****************************** */}
      {isMealCourse && (
        <MastersModalBox closeModal={hideMeal}>
          <MealCourseMaster
            isBackButton={false}
            isLogoutButton={true}
            SaveButtonName={"Save/F4"}
            isF4ListenForSave={true}
          />
        </MastersModalBox>
      )}
      {/* *****************************{Transport Master}****************************** */}
      {transportModal && (
        <MastersModalBox closeModal={hideTransporter}>
          <TransportMaster
            isBackButton={false}
            isLogoutButton={true}
            SaveButtonName={"Save/F4"}
            isF4ListenForSave={true}
          />
        </MastersModalBox>
      )}
      {/* *****************************{Incentive Master}****************************** */}
      {/* {deliveryIncentiveModal && (
        <div onClick={hideDeliveryIncentive} className="modal-back">
          <div
            onClick={handleModalClick}
            style={{ zIndex: "5" }}
            className="OpticalField-modal increase_modal"
          >
            <div style={{ padding: "15px" }}>
              <div className="Modal-Display">
                <label className="close_modal" onClick={hideDeliveryIncentive}>
                  x
                </label>
              </div>
              <hr />
              <IncentiveMaster />
            </div>
          </div>
        </div>
      )} */}

      {deliveryIncentiveModal && (
        <MastersModalBox closeModal={hideDeliveryIncentive}>
          <IncentiveMaster
            isBackButton={false}
            isLogoutButton={true}
            SaveButtonName={"Save/F4"}
            isF4ListenForSave={true}
          />
        </MastersModalBox>
      )}
      {/* *****************************{Table Master}****************************** */}
      {isOpenTableMaster && (
        <div className="modal-back">
          <div
            style={{ zIndex: "5" }}
            className="OpticalField-modal increase_modal"
          >
            <div style={{ padding: "15px" }}>
              <div className="Modal-Display">
                <label className="close_modal" onClick={closeTableMaster}>
                  x
                </label>
              </div>
              <hr />
              <TableMaster
                tableGroupId={tableGroupId}
                editedDataModal={false}
              />
            </div>
          </div>
        </div>
      )}
      {/* *****************************{Table Master}****************************** */}
      {isOpenTransactionType && (
        <div className="modal-back">
          <div
            style={{ zIndex: "5" }}
            className="OpticalField-modal increase_modal"
          >
            <div style={{ padding: "15px", paddingTop: "30px" }}>
              <div className="Modal-Display">
                <label className="close_modal" onClick={CloseTransactionType}>
                  x
                </label>
              </div>

              <TransactionTypeList
                tableGroupId={tableGroupId}
                editedDataModal={false}
              />
            </div>
          </div>
        </div>
      )}

      {/* *****************************{Software Configuration}****************************** */}
      {isSoftwareConfigOpen && (
        <div className="modal-back">
          <div
            style={{ zIndex: "5", maxHeight: "90vh", overflowY: "auto" }}
            className="OpticalField-modal increase_modal"
          >
            <div style={{ padding: "15px" }}>
              <div className="flex-center">
                <label
                  style={{
                    fontWeight: "bold",
                    color: "#94001A",
                    fontSize: "20px",
                  }}
                >
                  Software Configuration
                </label>
                <label
                  className="close_modal"
                  onClick={toggleSoftwareConfigOpen}
                >
                  x
                </label>
              </div>
              <hr />
              <SoftwareConfigurationPopUP />
            </div>
          </div>
        </div>
      )}

      {/* MasterListReportFormat2 */}

      {isMasterListReportFormat2 && (
        <div className="modal-back">
          <div
            style={{ zIndex: "5" }}
            className="OpticalField-modal increase_modal"
          >
            <div style={{ padding: "15px", paddingTop: "30px" }}>
              <div className="Modal-Display">
                <label
                  className="close_modal"
                  onClick={toggleMasterListReportFormat2}
                >
                  x
                </label>
              </div>

              <MasterListReportFormat2 id={71} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ModalBoxMaster;
